(function () {
  "use strict";

  /*
   * AMEND 2026:
   * Variant-Sync darf niemals Produktkarten / Empfehlungen auf der Seite überschreiben.
   * Synchronisiert werden ausschließlich Formulare innerhalb des Hauptprodukts auf /products/*.
   */
  if (window.location.pathname.indexOf('/products/') !== 0) return;

  function getMainProductRoot() {
    return document.querySelector('.shopify-section--main-product') ||
      document.querySelector('product-rerender[id^="product-info-"]');
  }

  function getVariantId(root) {
    try {
      var fromUrl = new URL(window.location.href).searchParams.get('variant');
      if (fromUrl) return fromUrl;
    } catch (e) {}

    if (!root) return null;

    var enabledInput = root.querySelector('form[action*="/cart/add"] input[name="id"]:not([disabled])');
    if (enabledInput && enabledInput.value) return enabledInput.value;

    var fallbackInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    return fallbackInput && fallbackInput.value ? fallbackInput.value : null;
  }

  function syncMainProductForms(variantId) {
    var root = getMainProductRoot();
    if (!root || !variantId) return;

    root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = String(variantId);
    });
  }

  function syncFromCurrentState() {
    var root = getMainProductRoot();
    syncMainProductForms(getVariantId(root));
  }

  var originalReplaceState = history.replaceState;
  history.replaceState = function () {
    var result = originalReplaceState.apply(this, arguments);
    syncFromCurrentState();
    return result;
  };

  var originalPushState = history.pushState;
  history.pushState = function () {
    var result = originalPushState.apply(this, arguments);
    syncFromCurrentState();
    return result;
  };

  window.addEventListener('popstate', syncFromCurrentState);

  document.addEventListener('change', function (event) {
    var root = getMainProductRoot();
    if (root && root.contains(event.target)) {
      requestAnimationFrame(syncFromCurrentState);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', syncFromCurrentState, { once: true });
  syncFromCurrentState();
})();
